import { render } from "./ReceiptEditDialog.vue?vue&type=template&id=4be50e6a"
import script from "./ReceiptEditDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__